import Vue from 'vue'

const actions = {
    exportDataApi: ({state,rootGetters}, payload) => {
        return PORTAL_API.put('/companies/' + rootGetters.profile.company.id + '/export', payload, {responseType: 'blob'}).then(res => {
            if (res.status === 200) {
                // download file
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'export.xlsx');
                document.body.appendChild(link);
                link.click();
                // https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
                // IF IE
            } else {
                Vue.toasted.global.failedRequest({message: res.error});
            }
        }).catch(err => {
            if (err.response.status === 404) {
                Vue.toasted.global.failedRequest({message: 'Geen producten gevonden'});
            } else {
                Vue.toasted.global.failedRequest();
            }
            return err
        });
    },
}
export default actions